import React from 'react';
import { TimeInterval } from '../../types/types';
import { capitalizeFirstLetter } from '../../utils/caseUtils';
import useI18n from '../../hooks/useI18n';

interface PeriodSelectorProps {
  limit: TimeInterval;
  setLimit: (value: TimeInterval) => void;
  isMobile: boolean;
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  limit,
  setLimit,
  isMobile,
}) => {
  const { t } = useI18n();
  const periods: TimeInterval[] = ['day', 'week', 'month', 'year'];

  const getLocalizedPeriod = (period: TimeInterval): string => {
    const key = `analytics.dates.${period}`;
    return isMobile ? t(key).charAt(0) : t(key);
  };

  return (
    <ul className="flex gap-3 items-center">
      {periods.map((period) => (
        <li
          key={period}
          onClick={() => setLimit(period)}
          className={`${
            limit === period ? 'text-blue-500' : 'text-[#9B919D]'
          } cursor-pointer duration-150 px-2 py-1 hover:bg-gray-100`}
        >
          {getLocalizedPeriod(period)}
        </li>
      ))}
    </ul>
  );
};

export default PeriodSelector;
